module.exports = __webpack_public_path__ + "img/whatsapp.9ee0a270.svg";